import { jobService } from '../../../services/api';
import { useApi } from '../../../hooks/useApi';

export const fetchJobCategories = async (callApi) => {
  return callApi(() => jobService.fetchJobCategories());
};

export const fetchJobPostings = async (callApi, params) => {
  const {
    pageIndex = 1,
    pageSize = 12,
    searchText = '',
    categories = [],
    location = null,
    isBookmarked = false,
    isMyJobs = false,
  } = params;

  const requestBody = {
    pageIndex,
    pageSize,
    filters: {
      searchText: searchText.trim(),
      categoryIds: categories,
      location: location ? { place_id: location.place_id } : null,
      isBookmarked,
      isMyJobs,
    },
  };

  return callApi(() => jobService.fetchJobPostings(requestBody));
};

export const fetchJobDetails = async (callApi, jobuuid) => {
  return callApi(() => jobService.fetchJobDetails(jobuuid));
};

export const fetchJobDetailsByShareUrl = async (callApi, job_share_url) => {
  return callApi(() => jobService.fetchJobDetailsByShareUrl(job_share_url));
};

export const addJobPosting = async (callApi, jobData) => {
  const requestBody = {
    ...jobData,
    memberuuid: localStorage.getItem('memberID'),
  };
  return callApi(() => jobService.addJobPosting(requestBody));
};

export const editJobPosting = async (callApi, jobData) => {
  const requestBody = {
    ...jobData,
    memberuuid: localStorage.getItem('memberID'),
    updated_at: new Date().toISOString(),
  };
  return callApi(() => jobService.editJobPosting(requestBody));
};
